(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fomo-batman-animation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var positions = [{top:12,left:50},{top:50,left:15},{top:85,left:25},{top:50,left:75},{top:50,left:75}]
  var canvas1 = document.getElementById('canvas1');
  var canvas2 = document.getElementById('canvas2');
  var canvas3 = document.getElementById('canvas3');
  var ctx1 = canvas1.getContext('2d');
  var ctx2 = canvas2.getContext('2d');
  var ctx3 = canvas3.getContext('2d');
  
  var rainthroughnum = 500;
  var speedRainTrough = 25;
  var RainTrough = [];
  
  var rainnum = 500;
  var rain = [];
  
  var lightning = [];
  var lightTimeCurrent = 0;
  var lightTimeTotal = 0;
  
  var  maskTimeCurrent = 0
  var  maskTimeTotal = 0
  var logoTimeCurrent = 0;
  var logoTimeTotal = 0;
  var logoIndex = 4;
  var opac = 1;

  var skipped = false;
  
  var w = canvas1.width = canvas2.width = canvas3.width = window.innerWidth;
  var h = canvas1.height = canvas2.height = canvas3.height = window.innerHeight;
  window.addEventListener('resize', function() {
    w = canvas1.width = canvas2.width = canvas3.width = window.innerWidth;
    h = canvas1.height = canvas2.height = canvas3.height = window.innerHeight;
  });
  
  function random(min, max) {
    return Math.random() * (max - min + 1) + min;
  }
  
  function clearcanvas1() {
    ctx1.clearRect(0, 0, w, h);
  }
  
  function clearcanvas2() {
    ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
  }
  
  function clearCanvas3() {
    ctx3.globalCompositeOperation = 'destination-out';
    ctx3.fillStyle = 'rgba(0,0,0,' + random(1, 30) / 100 + ')';
    ctx3.fillRect(0, 0, w, h);
    ctx3.globalCompositeOperation = 'source-over';
  };
  
  function createRainTrough() {
    for (var i = 0; i < rainthroughnum; i++) {
      RainTrough[i] = {
        x: random(0, w),
        y: random(0, h),
        length: Math.floor(random(1, 830)),
        opacity: Math.random() * 0.2,
        xs: random(-2, 2),
        ys: random(10, 20)
      };
    }
  }
  
  function createRain() {
    for (var i = 0; i < rainnum; i++) {
      rain[i] = {
        x: Math.random() * w,
        y: Math.random() * h,
        l: Math.random() * 1,
        xs: -4 + Math.random() * 4 + 2,
        ys: Math.random() * 10 + 10
      };
    }
  }
  
  function createLightning() {
    var x = random(100, w - 100);
    var y = random(0, h / 4);
  
    var createCount = random(1, 3);
    for (var i = 0; i < createCount; i++) {
      single = {
        x: x,
        y: y,
        xRange: random(5, 30),
        yRange: random(10, 25),
        path: [{
          x: x,
          y: y
        }],
        pathLimit: random(40, 55)
      };
      lightning.push(single);
    }
  };
  
  function drawRainTrough(i) {
    ctx1.beginPath();
    var grd = ctx1.createLinearGradient(0, RainTrough[i].y, 0, RainTrough[i].y + RainTrough[i].length);
    grd.addColorStop(0, "rgba(255,255,255,0)");
    grd.addColorStop(1, "rgba(255,255,255," + RainTrough[i].opacity + ")");
  
    ctx1.fillStyle = grd;
    ctx1.fillRect(RainTrough[i].x, RainTrough[i].y, 1, RainTrough[i].length);
    ctx1.fill();
  }
  
  function drawRain(i) {
    ctx2.beginPath();
    ctx2.moveTo(rain[i].x, rain[i].y);
    ctx2.lineTo(rain[i].x + rain[i].l * rain[i].xs, rain[i].y + rain[i].l * rain[i].ys);
    ctx2.strokeStyle = 'rgba(174,194,224,0.5)';
    ctx2.lineWidth = 1;
    ctx2.lineCap = 'round';
    ctx2.stroke();
  }
  
  function drawLightning() {
    for (var i = 0; i < lightning.length; i++) {
      var light = lightning[i];
  
      light.path.push({
        x: light.path[light.path.length - 1].x + (random(0, light.xRange) - (light.xRange / 2)),
        y: light.path[light.path.length - 1].y + (random(0, light.yRange))
      });
  
      if (light.path.length > light.pathLimit) {
        lightning.splice(i, 1);
      }
  
      ctx3.strokeStyle = 'rgba(255, 255, 255, .1)';
      ctx3.lineWidth = 3;
      if (random(0, 15) === 0) {
        ctx3.lineWidth = 6;
      }
      if (random(0, 30) === 0) {
        ctx3.lineWidth = 8;
      }
  
      ctx3.beginPath();
      ctx3.moveTo(light.x, light.y);
      for (var pc = 0; pc < light.path.length; pc++) {
        ctx3.lineTo(light.path[pc].x, light.path[pc].y);
      }
      if (Math.floor(random(0, 30)) === 1) { //to fos apo piso
        ctx3.fillStyle = 'rgba(255, 255, 255, ' + random(1, 3) / 100 + ')';
        ctx3.fillRect(0, 0, w, h);
      }
      ctx3.lineJoin = 'miter';
      ctx3.stroke();
    }
  };
  
  function animateRainTrough() {
    clearcanvas1();
    for (var i = 0; i < rainthroughnum; i++) {
      if (RainTrough[i].y >= h) {
        RainTrough[i].y = h - RainTrough[i].y - RainTrough[i].length * 5;
      } else {
        RainTrough[i].y += speedRainTrough;
      }
      drawRainTrough(i);
    }
  }
  
  function animateRain() {
    clearcanvas2();
    for (var i = 0; i < rainnum; i++) {
      rain[i].x += rain[i].xs;
      rain[i].y += rain[i].ys;
      if (rain[i].x > w || rain[i].y > h) {
        rain[i].x = Math.random() * w;
        rain[i].y = -20;
      }
      drawRain(i);
    }
  }
  
  function animateLightning() {
    clearCanvas3();
    lightTimeCurrent++;
    var today = new Date();
    if (lightTimeCurrent >= lightTimeTotal) {
      createLightning();
      lightTimeCurrent = 0;
      lightTimeTotal = 200;  //rand(100, 200)
    }
    drawLightning();
  }
  
  function animateLogo() {
    logoTimeCurrent++;
    if (logoTimeCurrent >= logoTimeTotal) {
      logoTimeCurrent = 0;
      logoTimeTotal = 180;
      const logo = document.getElementById('logo');
      if(logoIndex == (positions.length - 1)) logoIndex = 0;
      else{logoIndex++}
      const pos = positions[logoIndex];
      logo.style.left = `${pos.left}%`;
      logo.style.top = `${pos.top}%`;
    }
  }

  function animateMask() {
    maskTimeCurrent++;
    if (maskTimeCurrent >= maskTimeTotal) {
      maskTimeCurrent = 0;
      if(opac > 30) maskTimeTotal = 6; 
      else maskTimeTotal = 9;
      const cont = document.getElementById('fomo-mask-container');
      opac -= 0.01;
      
      cont.style.opacity = opac;
      
    }
  }
  
  function init() {
    createRainTrough();
    createRain();
    window.addEventListener('resize', createRainTrough);
  }
  init();
  
  function animloop() {
    animateRainTrough();
    animateRain();
    animateLightning();
    animateLogo();
    animateMask();
    if(document.getElementById('fomo-mask-container').style.opacity > 0.25 && !skipped){ requestAnimationFrame(animloop); }
    else {document.getElementById('fomo-mask-container').style.display = "none"};
  }

  document.getElementById('skip').addEventListener('click',function(){
    skipped = true;
  });
  
  if(window.sessionStorage['fomobatmanflag']){
    const cont = document.getElementById('fomo-mask-container');
    cont.style.display = 'none';
  } else{
    animloop();
    window.sessionStorage['fomobatmanflag'] = true;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fomo-holdingpage"] && !Shopify.designMode) return;
  try {
    
function redirect(event){
  event.preventDefault();
  location.href= document.getElementById('redirect_button').dataset.url;
}
function isnull(id){
  const input = document.getElementById(id);
  return input.value == null || input.value.trim() == '';
}
function validateEmailString(email) {
  var re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  return re.test(email);
}
function validateFirstname(event){
  const nameField = document.getElementById('ContactForm-firstname-field');
  const errorField = document.getElementById('ContactForm-firstname-error');
  if(isnull('ContactForm-firstname')){
    nameField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    nameField.classList.remove('error');
  }
}
function validateLastname(event){
  const nameField = document.getElementById('ContactForm-lastname-field');
  const errorField = document.getElementById('ContactForm-lastname-error');
  if(isnull('ContactForm-lastname')){
    nameField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    nameField.classList.remove('error');
  }
}
function validateEmail(event){
  const emailField = document.getElementById('ContactForm-email-field');
  const errorField = document.getElementById('ContactForm-email-error')
  const errorFormatField = document.getElementById('ContactForm-emailformat-error')
  if(isnull('ContactForm-email')){
    emailField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    emailField.classList.remove('error');
    if(!validateEmailString(document.getElementById('ContactForm-email').value)){
      emailField.classList.add('error');
      errorFormatField.style.display = 'block';
      event.preventDefault();
    }else{
      emailField.classList.remove('error');
      errorFormatField.style.display = 'none';
    }
  }
}
  
function validateForm(event){
  validateFirstname(event);
  //validateLastname(event);
  validateEmail(event);
}
  
document.addEventListener('DOMContentLoaded', function() {
  if(document.getElementById('btnSubmit')) document.getElementById('btnSubmit').addEventListener('mousedown',validateForm);
  if(document.getElementById('ContactForm-email')) document.getElementById('ContactForm-email').addEventListener('blur',validateEmail);
  if(document.getElementById('ContactForm-name')) document.getElementById('ContactForm-name').addEventListener('blur',validateName);
  if(document.getElementById('redirect_button')) document.getElementById('redirect_button').addEventListener('click',redirect);

  const fomoCarouselImages = document.getElementsByClassName("signup-carousel-image");
  const fomoCarouselCount = fomoCarouselImages.length;

  const unmute = document.getElementById('holding-video-unmute');
  if(unmute){
    unmute.addEventListener('click',function(){
      const v = document.getElementById('video');
      v.muted = !v.muted;
      const vt = document.getElementById('video-text');
      if(v.muted){ vt.innerText = vt.dataset.unmute; }
      else{ vt.innerText = vt.dataset.mute; }
    })
  }

  const unmutemobile = document.getElementById('holding-video-unmute-mobile');
  if(unmutemobile){
    unmutemobile.addEventListener('click',function(){
      const v = document.getElementById('video');
      v.muted = !v.muted;
      const vt = document.getElementById('video-text-mobile');
      if(v.muted){ vt.innerText = vt.dataset.unmute; }
      else{ vt.innerText = vt.dataset.mute; }
    })
  }

  if(fomoCarouselImages.length > 1){
    let index = 0;
    
    const speedSettings = document.getElementsByClassName("fomo-holding-page")[0];
    const speed = speedSettings.dataset && speedSettings.dataset.speed ? speedSettings.dataset.speed * 1000 : 4000;
    const swap = setInterval(async function() {
      const useMobile = window.innerWidth <= 900;
      const target = document.getElementsByClassName('fomo-signup-bg')[0];
      let targetUpdateDesktop = document.getElementsByClassName(`signup-carousel-image-${ index }`)[0];
      let targetElement = targetUpdateDesktop;
      if(useMobile){
        let targetUpdateMobile = document.getElementsByClassName(`signup-carousel-mobile-image-${ index }`);
        if(targetUpdateMobile.length > 0){
          targetElement = targetUpdateMobile[0];
        }
      }
      
      let textElement = document.getElementsByClassName('title-text');
      if(textElement.length > 0){
        let targetText = document.getElementsByClassName(`signup-carousel-image-text-${ index }`)[0];  
        textElement[0].innerText = targetText.innerText;
      }
      
      target.style['background-image'] = `url('${targetElement.src}')`;
      const images = document.getElementsByClassName('signup-carousel-target-image');
      for(let i = 0, c = images.length;i<c;i++){
        if(images[i].tagName == "IMG") images[i].src = targetElement.src;
      }
      index += 1;
      if(index == fomoCarouselCount) index = 0;
    },speed);
  };

  const signupTextPre = document.getElementById('fomo-signup-signedup-text-pre');
  const signupTextPost = document.getElementById('fomo-signup-signedup-text-post');
  const queryString = window.location.search;
  if((signupTextPre || signupTextPost) && queryString.indexOf('form_type=customer') > -1){
    const btnSubmit = document.getElementById('btnSubmit');
    const descriptionTextPre = document.getElementById('fomo-signup-description-text-pre');
    const descriptionTextPost = document.getElementById('fomo-signup-description-text-post');
    if(descriptionTextPost) descriptionTextPost.style.display = 'none';
    if(descriptionTextPre) descriptionTextPre.style.display = 'none';
    if(signupTextPre) signupTextPre.style.display = 'block';
    if(signupTextPost) signupTextPost.style.display = 'block';
    btnSubmit.disabled = true;
  }

  // UTM fields management
  const urlParams = new URLSearchParams(queryString);
  if(document.getElementById('utm_id')) { document.getElementById("utm_id").value = urlParams.get("utm_id"); }
  if(document.getElementById('utm_source')) { document.getElementById("utm_source").value = urlParams.get("utm_source"); }
  if(document.getElementById('utm_medium')) { document.getElementById("utm_medium").value = urlParams.get("utm_medium"); }
  if(document.getElementById('utm_campaign')) { document.getElementById("utm_campaign").value = urlParams.get("utm_campaign"); }				  
  if(document.getElementById('final_tags')) {
    const elements = Array.from(document.querySelectorAll('[name="contact[tags]"]'));
    const tags = elements.map(o => o.value).filter(val => val != null && val !== '').join(",");
    document.getElementById('final_tags').value = tags;    
  }
  // ~UTM fields management  
});

const fct = document.getElementById('fomo-holding-countdown-timer');
const maxWeek = 1000 * 60 * 24 * 7;
const maxDay = 1000 * 60 * 60 * 24;

const calendarButton = document.getElementById('add-to-calendar');
if(fct){
  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  
  const startDate = new Date(fct.dataset.startdate);
  const endDate = new Date(fct.dataset.enddate);
  const calendarEndDate = addDays(startDate,1);
  const nowTime = new Date().getTime();
  const startDiff = startDate.getTime() - nowTime;
  
  if(calendarButton && startDiff > 0){
    function ToRFCString(date){
      const y = date.getFullYear();
      const m = String(date.getMonth()+1).padStart(2,'0');
      const d = String(date.getDate()).padStart(2,'0'); 
      const h = String(date.getHours()).padStart(2,'0'); 
      const mi = String(date.getMinutes()).padStart(2,'0'); 
      const s = String(date.getSeconds()).padStart(2,'0'); 
      return `${y}${m}${d}T${h}${mi}${s}`;
    }
    
    const start = ToRFCString(startDate);
    const end = ToRFCString(calendarEndDate);
    const cDates = `${start}/${end}`;
    calendarButton.href=`https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${cDates}&details=${calendarButton.dataset.description}&text=${calendarButton.dataset.title}`;
    calendarButton.style.display = 'block';
  }
  
  const section = document.getElementById('fomo-holding-page');
  const designMode = section.classList.contains("designmode")
  if(!designMode){
    const endDiff = endDate.getTime() - nowTime;

    const observer = new MutationObserver(function(mutations){
      mutations.forEach(function(mutationRecord){
        if(mutationRecord.target.style.overflow == 'scroll'){
          mutationRecord.target.style.removeProperty('overflow');
        }
      })
    });

    observer.observe(document.body, { attributes : true, attributeFilter : ['style'] });

    const showPost = function(){
      const container = document.getElementById('fomo-holding-page-inner');
      const style = document.getElementById('holdingpage-stylesheet');
      const section = document.getElementById('fomo-holding-page');
      container.style.display = 'block';
      section.classList.add('post');
      style.sheet.cssRules[0].selectorText = 'body';
      section.classList.remove('pre');
      section.classList.remove('hidden');
    }

    const postTimer = function(){
      const nt = new Date().getTime();
      const ed = endDate.getTime() - nt;
      const timer = ed > maxDay ? maxDay : ed;
      const timeout = setInterval(function(){
        if(ed > 0){
          postTimer();
        }else{
          showPost();
        }
        clearInterval(timeout);
      },timer);
    }
    
    const sale = function(){
      const nt = new Date().getTime();
      const ed = endDate.getTime() - nt;
      const style = document.getElementById('holdingpage-stylesheet');
      style.sheet.cssRules[0].selectorText = 'body_ignore'
      const section = document.getElementById('fomo-holding-page');
      section.classList.add('hidden');
      postTimer();
    }
    if(startDiff <= 0 && endDiff > 0) sale();
    else {
      const section = document.getElementById('fomo-holding-page');
      const container = document.getElementById('fomo-holding-page-inner');
      container.style.display = 'block';
      if(startDiff > 0){
        section.classList.add('pre');
        if(maxWeek > startDiff){
          const timeout = setInterval(function(){ 
            sale();
            clearInterval(timeout);
          },startDiff);
        }
      } else {
        section.classList.add('post');
      }
    }
    const hbtn = document.getElementById('hidden-button');
    hbtn.addEventListener('click',function(){
      var password = prompt("Enter in the password");
      if(password.trim() == hbtn.dataset.p){
        sale();
      }
    })
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fomo-signup"] && !Shopify.designMode) return;
  try {
    
function redirect(event){
  event.preventDefault();
  location.href= document.getElementById('redirect_button').dataset.url;
}
function isnull(id){
  const input = document.getElementById(id);
  return input.value == null || input.value.trim() == '';
}
function validateEmailString(email) {
  var re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  return re.test(email);
}
function validateFirstname(event){
  const nameField = document.getElementById('ContactForm-firstname-field');
  const errorField = document.getElementById('ContactForm-firstname-error');
  if(isnull('ContactForm-firstname')){
    nameField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    nameField.classList.remove('error');
  }
}
function validateLastname(event){
  const nameField = document.getElementById('ContactForm-lastname-field');
  const errorField = document.getElementById('ContactForm-lastname-error');
  if(isnull('ContactForm-lastname')){
    nameField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    nameField.classList.remove('error');
  }
}
function validateEmail(event){
  const emailField = document.getElementById('ContactForm-email-field');
  const errorField = document.getElementById('ContactForm-email-error')
  const errorFormatField = document.getElementById('ContactForm-emailformat-error')
  if(isnull('ContactForm-email')){
    emailField.classList.add('error');
    errorField.style.display = 'block';
    event.preventDefault();
  }else{
    errorField.style.display = 'none';
    emailField.classList.remove('error');
    if(!validateEmailString(document.getElementById('ContactForm-email').value)){
      emailField.classList.add('error');
      errorFormatField.style.display = 'block';
      event.preventDefault();
    }else{
      emailField.classList.remove('error');
      errorFormatField.style.display = 'none';
    }
  }
}
  
function validateForm(event){
  validateFirstname(event);
  //validateLastname(event);
  validateEmail(event);
}
document.addEventListener('DOMContentLoaded', function() {
  if(document.getElementById('btnSubmit')) document.getElementById('btnSubmit').addEventListener('mousedown',validateForm);
  if(document.getElementById('ContactForm-email')) document.getElementById('ContactForm-email').addEventListener('blur',validateEmail);
  if(document.getElementById('ContactForm-name')) document.getElementById('ContactForm-name').addEventListener('blur',validateName);
  if(document.getElementById('redirect_button')) document.getElementById('redirect_button').addEventListener('click',redirect);
  
  const signupText = document.getElementById('fomo-signup-signedup-text');
  const queryString = window.location.search;
  if(signupText && queryString.indexOf('form_type=customer') > -1){
    const btnSubmit = document.getElementById('btnSubmit');
    const descriptionText = document.getElementById('fomo-signup-description-text');
    descriptionText.style.display = 'none';
    signupText.style.display = 'block';
    btnSubmit.disabled = true;
  }
  // UTM fields management
  const urlParams = new URLSearchParams(queryString);
  if(document.getElementById('utm_id')) { document.getElementById("utm_id").value = urlParams.get("utm_id"); }
  if(document.getElementById('utm_source')) { document.getElementById("utm_source").value = urlParams.get("utm_source"); }
  if(document.getElementById('utm_medium')) { document.getElementById("utm_medium").value = urlParams.get("utm_medium"); }
  if(document.getElementById('utm_campaign')) { document.getElementById("utm_campaign").value = urlParams.get("utm_campaign"); }				  
  if(document.getElementById('final_tags')) {
    const elements = Array.from(document.querySelectorAll('[name="contact[tags]"]'));
    const tags = elements.map(o => o.value).filter(val => val != null && val !== '').join(",");
    document.getElementById('final_tags').value = tags;    
  }
  // ~UTM fields management  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
